import { _ as t } from "./main28.js";
var n = t;
function o(r) {
  return r == null ? "" : n(r);
}
var a = o;
export {
  a as t
};
